import React, { useState } from 'react'
import { Alert, Button, Form, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import axios from 'axios'
import FormConfirmEmail from './FormConfirmEmail';
import fontColorContrast from 'font-color-contrast';

const FormRestore = ({ tabs, inputsData, setIsAllowClear }) => {

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: { errors, isValid },
    } = useForm({
        mode: 'onChange',
    })


    const {
        button_color,
        text_4, // заголовок для Востановление пароля
        text_5, // кнопка для Востановления отправить емаил   

    } = inputsData?.setting

    const [isLoading, setIsLoading] = useState(false)
    const [isConfirmMode, setIsConfirmMode] = useState(false)
    const [confirmResendData, setConfirmResendData] = useState(null)


    const [isAlertError, setIsAlertError] = useState(false);
    const [textOnError, setTextOnError] = useState('');


    const onSubmit = (formData) => {


        // const info = await fetchClientInfo()
        setIsLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/forgot-password`, {
            email: formData.email
        }).then((response) => {
            if (response?.data) {
                if (response.data.res === 'Success') {
                    setIsConfirmMode(true)
                    setConfirmResendData(formData)
                    setIsAllowClear(false)
                    setIsAlertError(false)
                }

                if (response.data.res === 'Error') {
                    setIsAlertError(true)
                    const errText = inputsData?.setting?.[response.data?.msgKey] || 'Что-то пошло не так, попробуйте повторить позже'
                    setTextOnError(errText)
                }
            }
        }).catch(err => {
            console.error(err)
        }).finally(() => {
            setIsLoading(false)
        })
    }
    return (
        <div>
            {
                isConfirmMode ?
                    <FormConfirmEmail
                        routeToConfirm='cabinet/forgot-password'
                        data={inputsData}
                        handleResend={() => {
                            onSubmit(confirmResendData)
                        }}
                        confirmResendData={confirmResendData}
                    />
                    :
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="d-flex" style={{ marginTop: -47 }}>
                            <Button
                                type='button'
                                variant="link"
                                onClick={() => {
                                    tabs(1);
                                    setIsAllowClear(true)
                                }}
                                style={{ width: 'auto', margin: 0, padding: 0 }}
                            >
                                Назад
                            </Button>
                        </div>
                        {
                            isAlertError &&
                            <Alert variant={'danger'} onClose={() => {
                                setIsAlertError(false)
                                setTextOnError('')
                            }} dismissible>
                                <Alert.Heading style={{ fontSize: '1.15rem' }}>Ошибка</Alert.Heading>
                                <p className='mb-0'>{textOnError}</p>
                            </Alert>
                        }

                        {text_4 && <div className='my-2 text-center' dangerouslySetInnerHTML={{ __html: text_4 }} />}

                        <Form.Control
                            className='mb-3'
                            placeholder={'Введите E-mail'}
                            type="email"
                            {...register('email', {
                                required: true,
                                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                            })}
                        />
                        <Form.Group controlId="logPass">
                            <button
                                disabled={!isValid}
                                className='btn btn-submit'
                                type='submit'
                                style={{
                                    backgroundColor: button_color,
                                    color: fontColorContrast(button_color)
                                }}
                            >
                                {
                                    isLoading ?
                                        <Spinner animation='border' />
                                        :
                                        <div dangerouslySetInnerHTML={{ __html: text_5 || "Отправить" }}></div>
                                }
                            </button>
                        </Form.Group>
                    </form>
            }
        </div>
    )
}

export default FormRestore